import React from "react";

const CandidateFilledIcon = ({ cls }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cls}
    >
      <path
        d="M12.5 12C15.2614 12 17.5 9.76142 17.5 7C17.5 4.23858 15.2614 2 12.5 2C9.73858 2 7.5 4.23858 7.5 7C7.5 9.76142 9.73858 12 12.5 12Z"
        fill="currentColor"
      />
      <path
        d="M12.5 14C8.35977 14.0044 5.00461 17.2254 5 21.2C5 21.6418 5.37309 22 5.83332 22H19.1667C19.6269 22 20 21.6418 20 21.2C19.9954 17.2254 16.6403 14.0044 12.5 14Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default CandidateFilledIcon;
